import { type ComponentProps } from 'react'

import { FormControl } from './form'
import { SingleDatePicker } from '../date-picker'

export const FormSingleDatePicker = (
  props: ComponentProps<typeof SingleDatePicker>,
) => {
  return (
    <FormControl>
      <SingleDatePicker {...props} />
    </FormControl>
  )
}
